import { connect } from 'react-redux'
import BillingAccountFormEssentialStep from './BillingAccountFormEssentialStep'

const stateToProps = ({}, { formData }) => {
  return {
    // loading: formData.isLoading || false,
  }
}

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(BillingAccountFormEssentialStep)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountFormEssentialStep/BillingAccountFormEssentialStep.container.js